<script setup lang="ts">
import {useNavigationProgressStore} from '@/shared/stores/navigationProgress.store';

const navigationProgress = useNavigationProgressStore();
</script>

<template>
   <div
      class="navigation-progress-bar"
      :class="{visible: navigationProgress.isVisible}"
      :style="{width: `${navigationProgress.progress}%`}"
   ></div>
</template>

<style scoped lang="scss">
.navigation-progress-bar {
   position: fixed;
   top: 0;
   left: 0;
   height: 3px;
   // Matches the loading-spinner green already used elsewhere (e.g.
   // ButtonSpinnerView in the metadata table rows) so this reads as the same
   // "something is loading" signal rather than a new, unrelated color.
   background-color: #218838;
   box-shadow: 0 0 6px 0 rgba(33, 136, 56, 0.7);
   z-index: 2000;
   opacity: 0;
   pointer-events: none;
   transition: width 0.2s ease, opacity 0.2s ease;

   &.visible {
      opacity: 1;
   }
}
</style>
